import HttpClient from 'flow-doctor-lib/constants/HttpClient';
import { registerQuery } from 'data-fetching-client';
import { getIsHubteamSubdomain } from 'flow-doctor-lib/constants/Env';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
export const GET_FLOW_DOCTOR_TIMELINE = registerQuery({
  fieldName: 'flowDoctorTimeline',
  args: ['portalId', 'objectId', 'startTimestamp', 'endTimestamp', 'objectTypeId', 'flowId', 'timelineTypes'],
  fetcher({
    portalId,
    objectId,
    startTimestamp,
    endTimestamp,
    objectTypeId,
    flowId,
    timelineTypes
  }) {
    const query = {
      portalId,
      objectId,
      earliestTime: startTimestamp,
      latestTime: endTimestamp,
      objectTypeId,
      flowId,
      timelineTypes
    };
    if (getIsHubteamSubdomain() || getIsInternal()) {
      return HttpClient.get(`flow-doctor-internal/v3/timeline/flow/${flowId}/${objectTypeId}/${objectId}`, {
        query
      });
    }
    return HttpClient.get(`flow-doctor/v3/timeline/flow/${flowId}/${objectTypeId}/${objectId}`, {
      query
    });
  }
});
export const GET_FLOW_DOCTOR_ENROLLMENT_DIAGNOSIS = registerQuery({
  fieldName: 'flowDoctorEnrollmentDiagnosis',
  args: ['portalId', 'enrollmentId'],
  fetcher({
    portalId,
    enrollmentId
  }) {
    if (getIsHubteamSubdomain() || getIsInternal()) {
      return HttpClient.get(`flow-doctor-internal/v3/diagnose/enrollment/${enrollmentId}`, {
        query: {
          portalId
        },
        timeout: 60000
      });
    }
    return HttpClient.get(`flow-doctor/v3/diagnose/enrollment/${enrollmentId}`, {
      query: {
        portalId
      },
      timeout: 60000
    });
  }
});
export const GET_HISTORICAL_LIST_EVAL_BATCH = registerQuery({
  fieldName: 'historicalListEvalBatch',
  args: ['portalId', 'listIds', 'timestamp', 'objectTypeId', 'objectId'],
  fetcher({
    portalId,
    listIds,
    timestamp,
    objectTypeId,
    objectId
  }) {
    if (getIsHubteamSubdomain() || getIsInternal()) {
      return HttpClient.post('flow-doctor-internal/v3/historical-list-eval/batch', {
        query: {
          portalId
        },
        data: {
          listIds,
          timestamp,
          objectTypeId,
          objectId
        },
        timeout: 60000
      });
    }
    return HttpClient.post('flow-doctor/v3/historical-list-eval/batch', {
      query: {
        portalId
      },
      data: {
        listIds,
        timestamp,
        objectTypeId,
        objectId
      },
      timeout: 60000
    });
  }
});
export const GET_NON_ENROLLMENT_DIAGNOSIS = registerQuery({
  fieldName: 'nonEnrollmentDiagnosis',
  args: ['portalId', 'flowId', 'objectId', 'timelineItem'],
  fetcher({
    portalId,
    flowId,
    objectId,
    timelineItem
  }) {
    if (getIsHubteamSubdomain() || getIsInternal()) {
      return HttpClient.post('flow-doctor-internal/v3/historical-enrollment/simulate', {
        query: {
          portalId
        },
        data: {
          flowId,
          objectId,
          timelineItem
        },
        timeout: 30000
      });
    }
    return HttpClient.post('flow-doctor/v3/historical-enrollment/simulate', {
      query: {
        portalId
      },
      data: {
        flowId,
        objectId,
        timelineItem
      },
      timeout: 30000
    });
  }
});